import React from 'react'
import styled from 'styled-components'

interface CardIconProps {
    children?: React.ReactNode,
    size?:number
}

const CardIcon: React.FC<CardIconProps> = ({children,size}) => (
    <StyledCardIcon size={80}>
        {children}
    </StyledCardIcon>
);

const StyledCardIcon = styled.div<{size:number}>`
  font-size: 36px;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  border-radius: 90px;
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0 auto ${props => props.theme.spacing[3]}px;
  box-shadow: 0 4px 18px 0 rgba(0,0,0, 0.3);
  background: #203059;
  border: 1px solid #384A77;
  >img{
    display:block;
    width:${(props) => props.size -30}px;
    height:${(props) => props.size -30}px;
  }
`;

export default CardIcon
